import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';

import { AvailableLang } from 'ideta-library/lib/utils/utils';

import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProtocolDroidService {
  // onTranslationChangeEvent is BehaviorSubject because we need first subscribe to fire
  public onTranslationChangeEvent: BehaviorSubject<null>;
  public currentLang$: BehaviorSubject<AvailableLang>;
  private defaultLang: AvailableLang;
  private translations: { [lang in AvailableLang]?: any };

  public get fulldateFormat() {
    return this.translate('misc.formats.fulldate', 'M/d/yy') || 'medium';
  }

  private get currentLang() {
    return this.currentLang$.value;
  }

  private get translation() {
    return this.translations[this.currentLang];
  }

  constructor(private http: HttpClient) {
    this.defaultLang = 'en';
    this.translations = {};
    this.currentLang$ = new BehaviorSubject<AvailableLang>(this.defaultLang);
    this.currentLang$.subscribe((lang: AvailableLang) => this.loadLang(lang));
    this.onTranslationChangeEvent = new BehaviorSubject(null);
  }

  translate(address: string, defaultValue?: string, params?: any, silent?: boolean): string | any {
    if (!this.translation) return;

    const addressArray = address.split('.');
    let translatedText = addressArray.reduce(
      (addressTree: any, addressSegment: string) => (addressTree && addressTree[addressSegment] ? addressTree[addressSegment] : null),
      this.translation
    );

    if (!translatedText && !silent && environment.name !== 'production') {
      console.warn(`Missing Translation '${address}'`);
    } else if (translatedText) {
      const matchedParams = translatedText.match(/\${\w+}/g);

      if (matchedParams) {
        translatedText = matchedParams.reduce((text: string, match: string) => this.replaceStringByParam(text, match, params), translatedText);
      }
    }

    return translatedText || defaultValue || '';
  }

  setLang(lang: AvailableLang) {
    // handling langs formats like fr-FR, es-ES ...
    const parsedLang = RegExp('fr').test(lang) ? 'fr' : RegExp('es').test(lang) ? 'es' : RegExp('de').test(lang) ? 'de' : this.defaultLang;
    if (parsedLang === this.currentLang) return;
    this.currentLang$.next(parsedLang);
  }

  private loadLang(lang: AvailableLang) {
    return this.http
      .get(`assets/i18n/${lang}.json`)
      .pipe(take(1))
      .subscribe((translation: any) => {
        this.translations[lang] = translation;
        this.onTranslationChangeEvent.next(null);
      });
  }

  private replaceStringByParam(text: string, match: string, params: Record<string, string>) {
    const paramKey = match.substring(2, match.length - 1);

    if (!params || !params.hasOwnProperty(paramKey)) {
      console.error(`Missing Translation param '${paramKey}' in '${text}'`);
    }

    return text.split(match).join(params[paramKey]);
  }
}
